import script from "./AddPensionPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./AddPensionPage.vue?vue&type=script&setup=true&lang=ts"

import "./AddPensionPage.vue?vue&type=style&index=0&id=213fd2b7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-213fd2b7"]])

export default __exports__